module.exports = __webpack_public_path__ + "img/ashley-headshot.babc9ec.jpg";